import React from 'react';
import ReactDOM from 'react-dom/client'; // Update the import for ReactDOM
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

// Get the root element
const rootElement = document.getElementById('root');

// Create a root with ReactDOM.createRoot
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
